document.addEventListener('DOMContentLoaded', function () {
  let pressSlider = new Swiper('.press__slider:not(.press__slider--page)', {
    slidesPerView: 4,
    spaceBetween: 15,
    navigation: {
      nextEl: ".press__controlls .controlls__button--next",
      prevEl: ".press__controlls .controlls__button--prev",
    },
    breakpoints: {
      300: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 15,
      }
    }
  })
});